document.addEventListener('click', function (event) {
	if (event.target.matches('.footer-block__heading')) {
		const footerMenu = document.querySelectorAll('.footer-block__heading')
		footerMenu.forEach((menu) => {
			if (!(menu == event.target)) {
				menu.parentNode.classList.remove('active');
			}
		})
		event.target.parentNode.classList.toggle('active');
	}
})